document.addEventListener("DOMContentLoaded", function() {
    if (window.screen.width >= 990) {
        const pdas = document.getElementById("pdas");
        const pdaclose = document.getElementById("pdasc");

        const togglePda = (action) => {
            const pdacontent = pdas.querySelector(".product-info__sticky-column__wrapper");
            if (action === 'open') {
                pdacontent.classList.add("product-info__sticky-column__wrapper-active");
                pdaclose.classList.add("show-button");
                pdacontent.style.maxHeight = pdacontent.scrollHeight + "px";
            } else {
                pdacontent.classList.remove("product-info__sticky-column__wrapper-active");
                pdaclose.classList.remove("show-button");
                pdacontent.style.maxHeight = null;
            }
        };

        pdas.addEventListener('click', () => {
            const pdacontent = pdas.querySelector(".product-info__sticky-column__wrapper");
            if (!pdacontent.style.maxHeight) {
                togglePda('open');
            }
        });

        pdaclose.addEventListener('click', (event) => {
            event.stopPropagation();
            togglePda('close');
        });

        const handleDocumentClick = (event) => {
            if (pdas && !pdas.contains(event.target)) {
                togglePda('close');
            }
        };
        document.addEventListener("click", handleDocumentClick);

    } else {
        const paccordions = document.querySelectorAll(".product-info__sticky-column");

        const toggleAccordion = (paccordion, action) => {
            const pcontent = paccordion.querySelector(".product-accordion__content");
            if (action === 'open') {
                paccordion.classList.add("product-accordion__content-active");
                pcontent.style.maxHeight = pcontent.scrollHeight + "px";
            } else {
                paccordion.classList.remove("product-accordion__content-active");
                pcontent.style.maxHeight = null;
            }
        };

        paccordions.forEach((paccordion) => {
            const pintro = paccordion.querySelector(".summary__title");
            pintro.addEventListener('click', () => {
                const pcontent = paccordion.querySelector(".product-accordion__content");
                if (pcontent.style.maxHeight) {
                    toggleAccordion(paccordion, 'close');
                } else {
                    paccordions.forEach((accordion) => toggleAccordion(accordion, 'close'));
                    toggleAccordion(paccordion, 'open');
                }
            });
        });
    }
});